/* eslint-disable react/prop-types */
/* eslint-disable view-models/no-unused-meta */
// TODO: remove view-models/no-unused-meta and eslint-disable react/prop-types rule when this issue https://github.com/asbjornh/view-models/issues/18 is resolved
import React from 'react';
import Link from 'components/link';
import Icon from 'components/icon';
import PropTypes from 'prop-types';
import types from './navigation-between-articles-link-types';
import cn from 'classnames';

const NavigationBetweenArticlesLink = ({ url, text, openInNewTab, type }) => {
  return (
    <a
      href={url}
      className={cn('navigation-between-articles-link', {
        [`navigation-between-articles-link_${type}`]: type,
      })}
      target={openInNewTab ? '_blank' : null}
      rel={openInNewTab ? 'nofollow noopener noreferrer' : null}
    >
      {type === types.prev && (
        <Icon
          name="arrow-right"
          className="navigation-between-articles-link__icon navigation-between-articles-link__icon_prev"
        />
      )}
      {text && (
        <span className="navigation-between-articles-link__text">{text}</span>
      )}
      {type === types.next && (
        <Icon
          name="arrow-right"
          className="navigation-between-articles-link__icon navigation-between-articles-link__icon_next"
        />
      )}
    </a>
  );
};

NavigationBetweenArticlesLink.viewModelMeta = 'ignore';

NavigationBetweenArticlesLink.propTypes = Object.assign({}, Link.propTypes, {
  type: PropTypes.oneOf(Object.values(types)),
});

export default NavigationBetweenArticlesLink;
